module.exports = __webpack_public_path__ + "img/window-log-in.30a0b32c.png";